import { render, staticRenderFns } from "./OrderFields.vue?vue&type=template&id=23e7bcca&scoped=true"
import script from "./OrderFields.vue?vue&type=script&lang=js"
export * from "./OrderFields.vue?vue&type=script&lang=js"
import style0 from "./OrderFields.vue?vue&type=style&index=0&id=23e7bcca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e7bcca",
  null
  
)

export default component.exports